import { css } from '@emotion/react';

import colors from './colors';

export default css`
  :root {
    ${colors};
  }
`;
